import { Loader2, Sparkles } from "lucide-react";

export function AnalyzingView() {
  return (
    <>
      <div className="flex items-center px-8 pt-7 pb-5 shrink-0">
        <h2 className="flex items-center gap-2 text-base font-semibold">
          <Sparkles className="h-4 w-4 text-purple-500" />
          Smart Product Upload
        </h2>
      </div>
      <div className="flex-1 flex flex-col items-center justify-center gap-4">
        <Loader2 className="h-10 w-10 animate-spin text-purple-500" />
        <p className="text-sm font-medium text-gray-600">
          The AI is identifying products and grouping similar angles together.
          This may take a moment...
        </p>
      </div>
    </>
  );
}
